import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLandingPage.css';

export default function AdminLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="admin-landing-wrapper">
    <div className="admin-landing-container">
      <div className="logo-wrapper">
        <img src="/How2Play_mainLogo512.png" alt="logo" className="logo" />
        <span className="beta-label"> how2play 관리자 <span className="beta">MODE</span></span>
      </div>

      <div className="headline">
        <h2>how2play로</h2>
        <h2>편리한 매장관리</h2>
      </div>

      <div className="button-group">
        <button className="primary" onClick={() => navigate('/owner/register')}>우리 가게 입점하기</button>
        <button className="secondary" onClick={() => navigate('/owner/login')}>관리자 로그인</button>
      </div>

      <div className="footer">how2play.kr</div>
    </div>
    </div>
  );
}
